import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { environment } from '../../../environments/environment';
import { ApolloConfigService } from './apollo-config.service';

@Injectable()
export class RealTimeService {
  private telemetryUrl = environment.telemetryServiceUrl;
  private telemetryUrlWS = environment.telemetryUrlWS;
  equipmentLocation: Map<string, Array<object>> = new Map();
  apolloClient: any; // aggiorna il tipo se necessario

  constructor(private apolloConfigService: ApolloConfigService) {
    this.apolloClient = apolloConfigService.apolloClient; // Assume che ApolloConfigService fornisca il client Apollo configurato
  }

  initRealTimeConnection() {
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));

    this.apolloClient
      .subscribe({
        query: gql`subscription {getMachineLocations(companyId: "${companySelected.id}" )}`,
        variables: {},
      })
      .subscribe({
        next: (data) => {
          if (data && data.data.getMachineLocations) {
            this.setLocationForEquipmentMap(data.data.getMachineLocations);
          }
        },
      });
  }

  parseML = (machineLocation) => {
    let result = null;
    let result1 = null;
    let result2 = null;
    try {
      result1 = JSON.parse(machineLocation);
      result = result1;
      try {
        result2 = JSON.parse(result1);
        result = result2;
      } catch (e) {
        result = result1;
      }
    } catch (e) {
      result = null;
    }
    return result;
  };

  setLocationForEquipmentMap(machineLocation) {
    const ml = this.parseML(machineLocation);
    if (ml && ml.externalId) {
      const existInMap = this.equipmentLocation.get(ml.externalId);
      if (existInMap) {
        existInMap.push(ml);
        this.equipmentLocation.set(ml.externalId, existInMap);
      } else {
        this.equipmentLocation.set(ml.externalId, [ml]);
      }
    }
  }

  getLocationForEquipment(equipmentId) {
    return this.equipmentLocation.get(equipmentId);
  }

  cleanLocationForEquipment(equipmentId) {
    this.equipmentLocation.set(equipmentId, []);
  }

  closeRealTimeConnection() {
    if (this.apolloClient.wsClient) {
      this.apolloClient.wsClient.unsubscribeAll();
      this.apolloClient.wsClient.close();
      this.equipmentLocation = new Map();
    }
  }
}
